<template>
  <div id="app">
    <section class="container">   
      <!-- <Timer/>    -->
      
      <Header />

    </section>
  </div>
</template>

<script>
import Header from './components/sections/Header'

export default {
  name: 'App',
  components: {
    Header,

  }
}
</script>

<style lang="sass" src="./index.sass"></style>

